import React from "react";
import NavigationBar from "./components/NavigationBar";
import Footer from "./components/Footer";
import PersonInfo from "./PersonInfo";
import StaffInfo from "./StaffInfo";
import UndergradInfo from "./UndergradInfo";

const OurTeam = () => {
  return (
    <div id="everything">
      <NavigationBar />
      <img src="./images/White Shirts on Stairs cropped.png" width={`100%`} alt="Staff and Students in the API Lab" />
      <br></br>
      <div className='text-center text-black justify-center text-xl md:text-5xl lg: text-6xl xl:text-7xl'>
        Lab Members
      </div>
      <br></br>
      <div className='text-left font-bold text-black mx-12 justify-center text-lg md:text-3xl lg: text-4xl xl:text-4xl'>
        Students
      </div>
      <br></br>
      <div className="mx-6">
      <PersonInfo 
        name="Sam Tcherner"
        degree="PhD Trainee"
        project="Evaluation of Pulmonary Imaging Measures in Obstructive Lung Disease"
        education="BSc Honours Medical and Biological Physics, McMaster University"
        email="stcherne@uwo.ca"
        StartDate="May 2023"
        imageUrl="./images/SamT.png"
      />
      <br></br>
      {/* <PersonInfo
        name="Ali Mozaffaripour"
        degree="MESc Trainee"
        project="Investigation of Airways Resistance using Hyperpolarized <sup>129</sup>Xe MRI Texture Features and Machine Learning"
        education="BMSc Honours Medical Biophysics, Western University"
        email="amozaff@uwo.ca"
        StartDate="May 2023"
        imageUrl="./images/AliM.png"
      />
      <br></br> */}
      <PersonInfo
        name="Eveline Durom"
        degree="PhD Trainee"
        project="Artificial Intelligence-based Approach for Detecting Mucus Plugs in Lung CT Images"
        education="BTech Honours Biomedical Engineering, APJ Abdul Kalam Technological University"
        email="edurom@uwo.ca"
        StartDate="September 2024"
        imageUrl="./images/EvelineD.png"
      />
      <br></br>
      <PersonInfo
        name="Yixiu (Helen) He"
        degree="MESc Trainee"
        project="Evaluating mucus clearance using Hyperpolarized <sup>129</sup>Xe MRI Texture Features and Machine Learning"
        education="BEng Biomedical Engineering, University of Guelph"
        email="yhe775@uwo.ca"
        StartDate="May 2025"
        imageUrl="./images/YixiuH.png"
      />
      <br></br>
      <PersonInfo
        name="Sarah Malik"
        degree="MESc Trainee"
        project=" Bayesian Time-Series Modeling of Hyperpolarized 129Xe MRI for Predicting Long-Term Ventilation Outcomes in Asthma"
        education="BMSc Honours Medical Biophysics, Western University"
        email="sarah.malik@uwo.ca"
        StartDate="September 2025"
        imageUrl="./images/SarahM.png"
      />
      <br></br>
      <PersonInfo
        name="Zahra Roozmand"
        degree="PhD Trainee"
        project=""
        education="MSc Health/Medical Physics,Shahid Sadoughi University of Medical Sciences"
        email="zroozman@uwo.ca"
        StartDate="January 2026"
        imageUrl="./images/ZahraR.png"
      />
      <br></br>
      <PersonInfo
        name="Parth Maheta"
        degree="MSc Trainee"
        project=""
        education="BSc Physics and Maths, Dalhousie University"
        email="pmaheta2@uwo.ca"
        StartDate="May 2026"
        imageUrl="./images/ParthM.png"
      />
      
      {/* <br></br><UndergradInfo
        name="Olivia Gater"
        title="Undergraduate Trainee"
        email="ogater2@uwo.ca"
        StartDate="May 2024"
        imageUrl="./images/OliviaG.png"
      />
      <br></br>
      <UndergradInfo
        name="Josh Peters"
        title="Undergraduate Trainee"
        email="jpete28@uwo.ca"
        StartDate="May 2024"
        imageUrl="./images/JoshP.png"
      />
      <br></br><UndergradInfo
        name="Eshan Patel"
        title="Undergraduate Trainee"
        email="epatel26@uwo.ca"
        StartDate="September 2024"
        imageUrl="./images/EshanP.png"
      /> */}
      {/* <br></br><UndergradInfo
        name="Mohib Dosani"
        title="Undergraduate Trainee"
        email="mdosani2@uwo.ca"
        StartDate="May 2025"
        imageUrl="./images/MohibD.png"
      />
      <br></br> */}
      <UndergradInfo
        name="Alex Hilbert"
        title="Research Assistant"
        email="ahilbert@uwo.ca"
        StartDate="September 2025"
        imageUrl="./images/AlexH.png"
      /> 
      {/* <UndergradInfo
        name="Daniel Yang"
        title="Co-op Student"
        email="dyang339@uwo.ca"
        StartDate="January 2025"
        imageUrl="./images/DanielY.png"
      />  */}

      <br></br>
      <br></br>
      </div>
      <div className='text-left font-bold text-black mx-12 justify-center text-lg md:text-3xl lg: text-4xl xl:text-4xl'>
        Staff
      </div>
      <br></br>
      <div className="mx-6">
      <StaffInfo 
        name="Angela Wilson"
        title="Clinical Research Manager"
        education="RRT, Fanshawe College"
        email="awilson@robarts.ca"
        StartDate="June 2020"
        imageUrl="./images/AngelaW.png"
      />
      <br></br>
      <StaffInfo 
        name="Courtney Heaman"
        title="Research Assistant"
        education="Medical Laboratory Assistant, Westervelt College"
        email="cheaman2@uwo.ca"
        StartDate="February 2025"
        imageUrl="./images/CourtneyH.png"
      />
      <br></br>
      <StaffInfo 
        name="Andraena Tilgner"
        title="Clinical Research Coordinator"
        education="Bachelor of Health Science (BHSc), Western University, Registered Respiratory Therapist(RRT), Fanshawe College"
        email="atilgner@uwo.ca"
        StartDate="March 2026"
        imageUrl="./images/AndraenaT.png"
      />
      <br></br>
      <StaffInfo 
        name="Mohammad Chalabi"
        title="Clinical Research Coordinator"
        education="Bachelor of Science (BSc), University of Windsor, Registered Respiratory Therapist(RRT), Fanshawe College"
        email="mchalab2@uwo.ca"
        StartDate="March 2026"
        imageUrl="./images/MoC.png"
      />
      <br></br>
      <StaffInfo 
        name="Dr. Reza Babaloo"
        title="Research Scientist: Clinical MRI Physicist"
        education="PhD Electrical and Electronics Engineering, Bilkent University, Turkey"
        email="rbabaloo@uwo.ca"
        StartDate="January 2026"
        imageUrl="./images/RezaB.png"
      />
      {/* <StaffInfo 
        name="Lauren Zelko"
        title="Regulatory and Data Coordinator"
        education="MSc, Medical Biophysics, Western University"
        email="lzelko@uwo.ca"
        StartDate="July 2023"
        imageUrl="./images/LaurenZ.png"
      /> */}
      </div>
      <br></br>
      <br></br>
        <div id="GraceBioContainer">
        <div id="GraceBio" className="person-info-container">
          <div className="headshot-container">
            <div className="mx-6">
            <img src="./images/GraceP.png" className="headshot" alt="Grace Parraga Head Shot" />
            </div>
          </div>
          <div className="info">
            <div className='text-left text-black justify-left mx-12 text-lg md:text-xl lg:text-2xl xl:text-4xl'>
              Dr. Grace Parraga
            </div>
            <div className='text-left text-black justify-left mx-12 text-base md:text-lg lg:text-xl xl:text-4xl'>
              <strong>Email:</strong> gparraga@uwo.ca
            </div>
          </div>
        </div>
        <div className="flex flex-col items-left"> 
        <br></br>
          <div className='text-left text-black justify-left mx-12 text-base md:text-lg lg:text-xl xl:text-4xl'>
            Dr. Grace Parraga is a Professor of Medicine and Medical Biophysics at Western University, London Canada
            as well as Scientist and Director of the Advanced Pulmonary Imaging Laboratories, at Robarts Research Institute. 
          </div>
          <br></br>
          <div className='text-left text-black justify-left mx-12 text-base md:text-lg lg:text-xl xl:text-4xl'>
            Grace was born and raised in Sudbury ON Canada and completed PhD training at the University of Washington,
            Seattle WA (NMR Spectroscopy of zinc fingers). Upon completion of a post-doctoral fellowship at the
            University of Basel, Switzerland, she joined F Hoffman La Roche, Pharmaceutical Research and Development as a
            Scientist, providing support to numerous EMEA and FDA submissions and approvals. She was recruited to Western
            in 2004 to spearhead the development of a clinical imaging research program in COPD and asthma.
          </div>
          <br></br>
          <div className='text-left text-black justify-left mx-12 text-base md:text-lg lg:text-xl xl:text-4xl'>
            Dr Parraga is a member of the Fleischner Society, a fellow of the Canadian Academy of Health Sciences and holds
            a Tier 1 Canada Research Chair (2018-2032). She has served on numerous national and international scientific committees
            as well as editorial panels of international journals. She currently serves on the board of the Canadian Thoracic
            Society (CTS), the German Lung Research Foundation (DZL) and as President of the International Workshop for Pulmonary Functional Imaging. 
          </div>
          <br></br>
          <div className='text-left text-black justify-left mx-12 text-base md:text-lg lg:text-xl xl:text-4xl'>
            Her research is focused on developing novel clinical imaging tools and measurements of chronic lung disease. At Western University,
            she has grown a highly productive research team which has been very successful in attracting peer-reviewed and industrial funding
            support for over 20 years. Dr Parraga’s outstanding trainees have also developed a network of pulmonary imaging research centres of
            excellence across Canada. She has lectured and published extensively, contributing over 250 peer-reviewed publications to date; her 
            lab is internationally recognized as a leader in pulmonary research and training. 
          </div>
          <br></br>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default OurTeam;